import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { BannerHeading } from '../components/BannerHeading';
import { HomeContent } from '../components/HomeContent';
import { Loader } from '../components/Loader';
import { forwarderConfig } from '../globals/ForwarderConfig';
import { useStoredState } from '../hooks/useStoredState';
import { MainLayout } from '../layouts/MainLayout';
import { statePropertiesEnum } from '../utility/enums';
import { goToSummaryOrUrl } from '../utility/goToSummaryOrUrl';
import { useGuid } from '../utility/useGuid';

const nextUrl = '/modeOfTransportation';

function Home() {
    const router = useRouter();
    const showBanner = !useGuid();
    // Stays true until we confirm no redirect is needed, preventing a flash of home content.
    const [resolving, setResolving] = useState(true);
    const flavorText = 'Navegate helps manage and track every part of a shipment\'s journey.<br/>Get started with a free shipment quote by answering a few questions below.';

    const {
        storedState: {
            range = '',
            isResponder = false,
            ownerRegistrantID = null,
            ready,
        },
        setStoredState,
        keepSelectedStateProperties
    } = useStoredState();

    // Wait for both session storage and the router query to be ready before deciding
    // whether to redirect to /selectClient or show the home content.
    useEffect(() => {
        if (!ready || !router.isReady) return;

        // ?responder param present — first time a responder opens the module
        if (router.query.responder === '') {
            router.push('/selectClient?clearSessionStorage&responder');

            return;
        }

        // isResponder already in session but no client selected yet
        if (isResponder && !ownerRegistrantID) {
            router.push('/selectClient');

            return;
        }

        // No redirect needed — safe to show home content
        setResolving(false);
    }, [ready, router.isReady, router.query.responder, isResponder, ownerRegistrantID]);

    function setRangeAndRedirect(newRange) {
        if (newRange === range) {
            goToSummaryOrUrl(nextUrl);
        } else {
            setStoredState({ range: newRange });
            keepSelectedStateProperties([statePropertiesEnum.range, statePropertiesEnum.ready, statePropertiesEnum.isResponder, statePropertiesEnum.ownerRegistrantID, statePropertiesEnum.ownerRegistrantName]);
            goToSummaryOrUrl(nextUrl);
        }
    }

    let banner;
    if (showBanner) {
        banner = (
            <BannerHeading
                text={flavorText}
                url={forwarderConfig[process.env.FORWARDER].logoSrc}
            />
        );
    }

    return (
        <MainLayout
            backUrl={isResponder ? '/selectClient' : undefined}
            banner={banner}
            hideNextButton
            showLogo={false}
        >
            {resolving ? (
                <Loader />
            ) : (
                <HomeContent
                    onDomesticClick={() => setRangeAndRedirect('domestic')}
                    onInternationalClick={() => setRangeAndRedirect('international')}
                    onOtherUnknownClick={() => setRangeAndRedirect('otherUnknown')}
                    range={range}
                />
            )}
        </MainLayout>
    );
}

export default Home;
